module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForWin_pic10.e3c4102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForWin/dataLeakInstallForWin_pic10.png
// module id = 489
// module chunks = 1